// ***************************************
// Definition of InventoryPowerUpSlot Model
// ***************************************
/**
 * The constructor for the InventoryPowerUpSlot game token.
 * @constructor
 */
export var InventoryPowerUpSlotModel = function () {
    "use strict";
};
/**
 * Defines if the slot is currently "opened"
 * @type {boolean}
 */
InventoryPowerUpSlotModel.prototype.unlocked = false;
/**
 * The index of the power up from the PowerUpSettings.
 * A value of -1 means that the slot is still regenerating (cool-down)
 * @type {number}
 */
InventoryPowerUpSlotModel.prototype.powerUp = -1;
